<template>
  <div
    :class="{'has-sirah': isSirah, 'selected-line': selected}"
    class="section-line section-text--line"
    :data-line-idx="line.idx"
    :data-section-idx="line.sectionIdx"
  >
    <sup v-if="debug">{{ debugIdx }}</sup>
    <keep-alive>
      <SectionBiographyLine v-if="isBiographyLine" :line="line"/>
      <SectionPoetryLine v-else-if="isPoetryLine" :line="line"/>
      <component v-else :is="contentContainerComponent">
        <LineTokens v-if="tokens.length" :tokens="tokens" :debug="debug" />
        <span v-else>{{ line.textContent }}</span>
      </component>
    </keep-alive>
  </div>
</template>

<script>
  import mixins from '../../mixins';
  import {
    LINE_KIND_CHAPTER_HEADER,
    LINE_KIND_SECTION_HEADER,
    LINE_KIND_PARAGRAPH,
    LINE_KIND_BIOGRAPHY,
    LINE_KIND_POETRY,
  } from '../../constants';
  import LineTokens from './LineTokens.vue';
  import SectionBiographyLine from './SectionBiographyLine.vue';
  import SectionPoetryLine from './SectionPoetryLine.vue';

  export default {
    components: {
      LineTokens,
      SectionBiographyLine,
      SectionPoetryLine,
    },
    mixins: [mixins.LocalizedWorkTitleMixin],
    props: ['line', 'alignments', 'selected', 'selectedToken', 'debug'],
    data() {
      return {
        tokens: [],
      };
    },
    mounted() {
      if (this.selected) {
        this.scrollToLine();
      }
    },
    computed: {
      debugIdx() {
        return `${this.line.sectionIdx}.${this.line.idx}`;
      },
      isSirah() {
        return this.line.isSirah;
      },
      isBiographyLine() {
        return this.line.kind === LINE_KIND_BIOGRAPHY;
      },
      isPoetryLine() {
        return this.line.kind === LINE_KIND_POETRY;
      },
      shouldSelectToken() {
        return this.selected && Number.isInteger(this.selectedToken);
      },
      contentContainerComponent() {
        switch (this.line.kind) {
          case LINE_KIND_PARAGRAPH:
            return 'p';
          case LINE_KIND_CHAPTER_HEADER:
            return 'h1';
          case LINE_KIND_SECTION_HEADER:
            return 'h2';
          default:
            return 'h3';
        }
      },
    },
    methods: {
      scrollToLine() {
        this.$emit('scrollToElement', this.$el);
      },
      populateTokens() {
        return this.line.textContent.split(' ').map((t, i) => ({ value: t, is_sirah: false, pos: i }));
      },
      getLineTokens() {
        // Only lines where isSirah === true have tokens populated from ATLAS.
        // If no tokens are populated, we'll split the text content and populate
        // them just-in-time
        const tokens = this.line.tokens.length > 0 ? this.line.tokens : this.populateTokens();
        return this.shouldSelectToken ? tokens.map((t, i) => this.setSelectedToken(t, i)) : tokens;
      },
      setSelectedToken(t, i) {
        const token = { ...t };
        token.selected = this.selectedToken === i;
        return token;
      },
    },
    created() {
      if (this.shouldSelectToken || this.isSirah) {
        this.tokens = this.getLineTokens();
        // console.log(`created scrollToLine ${this.line.idx}`);
        // this.scrollToLine();
      }
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';

  .section-text--line {
    padding-right: 10px;
    h1, h2, h3 {
      color: $brand;
      letter-spacing: normal;
      line-height: 1.3;
      >span:first-of-type {
        display: block;
      }
    }
    h1 {
      font-size: 1.6em;
    }
    h2 {
      font-size: 1.4em;
    }
    h3 {
      font-size: 1.2em;
    }
  }
</style>
